<template>
  <div id="container">
    <user-image :puntaje="puntaje" :img="imageUser"></user-image>
    <h2 class="animate__animated animate__fadeInDown">
      Paradigmas de Rotación
    </h2>
    <div class="info animate__animated animate__zoomIn">
      <p class="info_texto">
        Los cuaterniones unitarios proporcionan una notación matemática para
        representar las orientaciones y las rotaciones de objetos en tres
        dimensiones.
      </p>

      <div v-if="!siguiente" class="loader">
        <div class="loader-inner pacman">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else class="loader animate__animated animate__fadeIn">
        <font-awesome-icon
          icon="fa-solid fa-forward"
          class="next"
          @click="play()"
        />
      </div>
    </div>
    <div v-if="info1">
      <div>
        <h3 class="info1 animate__animated animate__fadeInRight">
          La rotacion euler es bastante facil de leer tenemos una rotacion en
          X,Y y Z => euler(45°,32°,15°) son 3 angulos en 3 ejes diferentes
        </h3>
        <h3 class="info2 animate__animated animate__fadeInRight">
          Sin embargo tambien existen los cuaterniones y aqui ya no es tan
          sencillo de asimilar ya que visualmente es muy dificil saber a que
          angulos corresponde
        </h3>
        <h3 class="info3 animate__animated animate__fadeInRight">
          por ejemplo cuaternio(0.3535,-0.3535,0.1434,0,8543) parecen numeros
          totalmente arbitrarios, por lo general los desarrolladores usan
          angulos euler ya que son mas sencillos de aplicar
        </h3>
      </div>
      <div class="step3">
        <h3 class="info4 animate__animated animate__fadeInRight">
          Como ya debemos saber cada eje tiene una matriz de rotacion como vemos
          a la izquierda en su forma mas basica
        </h3>
        <h3 class="info5 animate__animated animate__fadeInRight">
          cada eje tiene una matriz de rotacion segun su eje , y se modifica los
          valores que no correspondan a las filas y columnas de la matriz
          correspondiente al eje.
        </h3>
        <h3 class="info6 animate__animated animate__fadeInRight">
          Como cada angulo reprenta una matriz tenemos que convertir esto en una
          sola matriz es decir que tenemos que multiplicar todas las matrices
          para tener esa matriz de rotación.
        </h3>
      </div>
      <div class="step4">
        <h3 class="info7 animate__animated animate__fadeInRight">
          Sin embargo la multiplicacion de matrices es una operacion no
          conmutativa eso significa que el orden de los factores si altera el
          producto.
        </h3>
        <h3 class="info8 animate__animated animate__fadeInRight">
          Los cuaterniones destruyen todos estos problemas que nos dan los
          angulos euler, al convertirlos en matrices de rotacion invluyendo el
          error de <b>GIMBAL LOCK</b>.
        </h3>
        <div class="final">
          <h3 class="info9 animate__animated animate__fadeInRight">
            <b>¡Felicidades!</b> acabas de llegar al final de la explicación
            sobre Paradigmas de rotacion, espero puedas aclarar dudas en la
            siguiente demostracion de lo explicado.
          </h3>
        </div>
      </div>
    </div>
    <div v-if="info1" class="flechas">
      <a @click="leftBottonmCurse()" class="arrow left"></a>
      <a @click="rigthBottonmCurse()" class="arrow right"></a>
    </div>
    <div v-if="felicidades" class="felicidades">
      <img
        src="@/assets/img/icons3D/perspective_matte.png"
        alt="perspective_matte"
      />
      <h2>¡FELICITACIONES!</h2>
      <p>
        Acabas de obtener un logro, por finalizar la explicacion Teorica de
        <b> Paradigmas de Rotación</b> .
      </p>
      <router-link to="/demostracion-cuaterniones">Continuar</router-link>
    </div>

    <div
      v-if="felicidades"
      class="profundizacion animate__animated animate__fadeInLeft"
    >
      <h3>Te recomendamos ver este video</h3>
      <iframe
        src="https://www.youtube.com/embed/814EP5h0kEg"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>

    <menu-vertical class="menu"></menu-vertical>
  </div>
</template>
<script>
import * as Three from "three";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
// import BarraHerramientas from "@/components/BarraHerramientas.vue";
import MenuVertical from "@/components/MenuVertical.vue";
import UserImage from "@/components/UserImage.vue";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
var axios = require("axios");
export default {
  components: { MenuVertical, UserImage },
  name: "FondoIntro",
  data() {
    return {
      torusKnot: null,
      puntaje: 0,
      felicidades: false,
      logros: [],
      cont: 1,
      sphereU: null,
      textMesh1: null,
      axisZ: null,
      axisZr: null,
      cylinderZ: null,
      group: null,
      siguiente: false,
      camera: null,
      scene: null,
      renderer: null,
      gridHelper: null,
      gridHelperZX: null,
      gridHelperYZ: null,
      anim: null,
      text: "",
      info1: false,
      sphere: null,
      textMesh: null,
      textMeshY: null,
      textMeshZ: null,
      axisXCoor: null,
      axisZCoor: null,
      axisYCoor: null,
      decodeToken: null,
      imageUser:
        "https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png",
    };
  },
  props: {},
  methods: {
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        45,
        container.clientWidth / container.clientHeight,
        0.01,
        2000
      );
      this.camera.position.z = 16;
      this.scene = new Three.Scene();
      this.scene.rotation.x = Math.PI / 2;
      const size = 10;
      const divisions = 10;

      const geometry = new Three.PlaneGeometry(size, divisions);
      const material = new Three.MeshBasicMaterial({
        color: 0x0000ff,
        opacity: 0.3,
        transparent: true,
        side: Three.DoubleSide,
      });
      const materialRojo = new Three.MeshBasicMaterial({
        color: 0xff0000,
        opacity: 0.3,
        transparent: true,
        side: Three.DoubleSide,
      });
      const materialVerde = new Three.MeshBasicMaterial({
        color: 0x00ff00,
        opacity: 0.3,
        transparent: true,
        side: Three.DoubleSide,
      });
      this.gridHelper = new Three.Mesh(geometry, materialVerde);
      this.gridHelper.rotation.y = Math.PI / 2;
      this.gridHelper.position.y = 1;

      this.gridHelperYZ = new Three.Mesh(geometry, material);
      //   this.gridHel
      this.gridHelperYZ.rotation.x = Math.PI / 2;
      this.gridHelperYZ.position.y = 1;
      this.gridHelperZX = new Three.Mesh(geometry, materialRojo);
      this.gridHelperZX.rotation.z = Math.PI / 2;
      this.gridHelperZX.position.y = 1;

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      this.controls.update(); //must be called after any manual changes to the camera's transform
      this.controls.enablePan = false;
      this.controls.minAzimuthAngle = 0; // radians
      this.controls.maxAzimuthAngle = 0;
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate: function () {
      if (this.$router.history.current.path == "/cuaterniones") {
        window.addEventListener("resize", this.onWindowResize);
        if (this.torusKnot) {
          this.torusKnot.rotation.y += 0.01;
          this.torusKnot.rotation.z += 0.01;
        }
        requestAnimationFrame(this.animate);
        TWEEN.update();
        this.renderer.render(this.scene, this.camera);
      }
    },
    rigthBottonmCurse() {
      if (this.cont < 9) {
        this.cont += 1;
        this.switchCurse();
      }
      // console.log(this.cont);
    },
    leftBottonmCurse() {
      if (this.cont > 1) {
        this.cont -= 1;
        this.switchCurse();
      }
    },
    switchCurse() {
      console.log(this.cont);
      switch (this.cont) {
        case 1:
          this.step1();
          break;
        case 2:
          this.step2();
          break;
        case 3:
          this.step3();
          break;
        case 4:
          this.step4();
          break;
        case 5:
          this.step5();
          break;
        case 6:
          this.step6();
          break;
        case 7:
          this.step7();
          break;
        case 8:
          this.step8();
          this.felicidades = false;
          break;
        case 9:
          this.step9();
          break;

        default:
          break;
      }
    },
    play() {
      const info = document.querySelector(".info");
      info.classList.remove("animate__zoomIn");
      info.classList.add("animate__fadeOut");
      setTimeout(() => {
        info.style.display = "none";
        this.group.add(this.textMesh);
        this.group.add(this.textMeshY);
        this.group.scale.set(0.7, 0.7, 0.7);
        this.scene.add(this.group);
      }, 1000);
      new TWEEN.Tween(this.scene.rotation)
        .to(
          {
            x: 0,
          },
          3500
        )
        .easing(TWEEN.Easing.Cubic.InOut)
        .start();
      new TWEEN.Tween(this.scene.position)
        .to(
          {
            x: -5,
          },
          3500
        )
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {
          this.info1 = true;
        })
        .start();

      let maxX = 2;
      let axisXLength = maxX * 2;
      const axisXHeadLength = axisXLength * 0.25;
      const axisXHeadWidth = axisXHeadLength * 1;
      const directionX = new Three.Vector3(1, 0, 0);
      const directionXr = new Three.Vector3(-1, 0, 0);
      const startX = new Three.Vector3(-maxX, 0, 0);
      const colorX = 0xff0000;
      const axisX = new Three.ArrowHelper(
        directionX,
        startX,
        axisXLength + axisXHeadLength * 2,
        colorX,
        axisXHeadLength,
        axisXHeadWidth
      );
      const axisXr = new Three.ArrowHelper(
        directionXr,
        startX,
        axisXLength + axisXHeadLength * 2,
        colorX,
        axisXHeadLength,
        axisXHeadWidth
      );
      axisX.position.x = 0;
      axisX.position.y = 1;
      axisX.position.z = 0;
      axisXr.position.x = 0;
      axisXr.position.y = 1;
      axisXr.position.z = 0;

      const geometryX = new Three.CylinderGeometry(0.15, 0.15, 10, 32);
      const materialX = new Three.MeshPhongMaterial({ color: colorX });
      const cylinder = new Three.Mesh(geometryX, materialX);
      cylinder.rotation.z = Math.PI / 2;
      cylinder.position.x = 0;
      cylinder.position.y = 1;
      cylinder.position.z = 0;

      let axisYLength = maxX * 2;
      const axisYHeadLength = axisYLength * 0.25;
      const axisYHeadWidth = axisYHeadLength;
      const directionY = new Three.Vector3(0, 1, 0);
      const directionYr = new Three.Vector3(0, -1, 0);
      const startY = new Three.Vector3(0, maxX, 0);
      const colorY = 0x00ff00;
      const axisY = new Three.ArrowHelper(
        directionY,
        startY,
        axisYLength + axisYHeadLength * 2,
        colorY,
        axisYHeadLength,
        axisYHeadWidth
      );
      const axisYr = new Three.ArrowHelper(
        directionYr,
        startY,
        axisYLength + axisYHeadLength * 2,
        colorY,
        axisYHeadLength,
        axisYHeadWidth
      );
      axisY.position.x = 0;
      axisY.position.y = 1;
      axisY.position.z = 0;
      axisYr.position.x = 0;
      axisYr.position.y = 1;
      axisYr.position.z = 0;

      const materialY = new Three.MeshPhongMaterial({ color: colorY });
      const cylinderY = new Three.Mesh(geometryX, materialY);
      cylinderY.rotation.y = Math.PI / 2;
      cylinderY.position.x = 0;
      cylinderY.position.y = 1;
      cylinderY.position.z = 0;

      this.group = new Three.Group();

      const geometry = new Three.SphereGeometry(1, 32, 16);
      const material = new Three.MeshBasicMaterial({ color: 0xffff00 });
      this.sphere = new Three.Mesh(geometry, material);
      this.sphere.position.x = 0;
      this.sphere.position.y = 1;
      this.sphere.position.z = 0;

      let axisZLength = maxX * 2;
      const axisZHeadLength = axisZLength * 0.25;
      const axisZHeadWidth = axisZHeadLength;
      const directionZ = new Three.Vector3(0, 0, 1);
      const startZ = new Three.Vector3(0, 0, maxX);
      const colorZ = 0x0000ff;
      this.axisZ = new Three.ArrowHelper(
        directionZ,
        startZ,
        axisZLength + axisZHeadLength * 2,
        colorZ,
        axisZHeadLength,
        axisZHeadWidth
      );

      const directionZr = new Three.Vector3(0, 0, -1);

      this.axisZr = new Three.ArrowHelper(
        directionZr,
        startZ,
        axisZLength + axisZHeadLength * 2,
        colorZ,
        axisZHeadLength,
        axisZHeadWidth
      );
      this.axisZr.position.x = 0;
      this.axisZr.position.y = 1;
      this.axisZr.position.z = 0;
      this.axisZ.position.x = 0;
      this.axisZ.position.y = 1;
      this.axisZ.position.z = 0;

      const materialZ = new Three.MeshPhongMaterial({ color: colorZ });
      this.cylinderZ = new Three.Mesh(geometryX, materialZ);
      this.cylinderZ.rotation.x = Math.PI / 2;
      this.cylinderZ.position.x = 0;
      this.cylinderZ.position.y = 1;
      this.cylinderZ.position.z = 0;

      this.group.add(cylinderY);
      this.group.add(axisY);
      this.group.add(cylinder);
      this.group.add(axisX);
      this.group.add(axisYr);
      this.group.add(axisXr);
      this.group.rotation.x = 0;
      const light = new Three.AmbientLight(0xffffff, 0.5); // soft white light
      this.scene.add(light);
      const directionalLight = new Three.DirectionalLight(0xffffff);
      directionalLight.position.set(1, 1.75, 1.5).normalize();
      this.scene.add(directionalLight);

      const loader = new FontLoader();

      loader.load(
        "fonts/helvetiker_regular.typeface.json",
        (font) => {
          // console.log(font);
          let textoGeo = new TextGeometry("X", {
            font: font,
            size: 1,
            height: 0.5,
          });
          let textoGeoY = new TextGeometry("Y", {
            font: font,
            size: 1,
            height: 0.5,
          });
          let textoGeoZ = new TextGeometry("Z", {
            font: font,
            size: 1,
            height: 0.5,
          });
          let materials = new Three.MeshPhongMaterial({
            color: 0xffffff,
            // flatShading: true,
          });
          this.textMesh = new Three.Mesh(textoGeo, materials);
          this.textMeshY = new Three.Mesh(textoGeoY, materials);
          this.textMeshZ = new Three.Mesh(textoGeoZ, materials);

          this.textMesh.position.x = 6.5;
          this.textMesh.position.y = 0.7;
          this.textMesh.position.z = -0.25;

          this.textMeshY.position.y = 7.4;
          this.textMeshY.position.x = -0.25;
          this.textMeshY.position.z = -0.25;

          this.textMeshZ.position.y = 0.7;
          this.textMeshZ.position.x = 0.25;
          this.textMeshZ.position.z = -7.4;
          this.textMeshZ.rotation.x = Math.PI / 2;
          this.textMeshZ.rotation.y = Math.PI;
        },
        // Progreso de carga
        function (xhr) {
          console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        },
        // se produjo un error
        function (err) {
          console.log(err);
        }
      );
      this.group.add(this.cylinderZ);
      this.group.add(this.axisZr);
      this.group.add(this.axisZ);

      this.group.add(this.textMeshZ);
    },
    step1() {
      for (let i = 1; i <= 9; i++) {
        if (i <= 1) {
          document.querySelector(`.info${i}`).style.display = "block";
        } else {
          document.querySelector(`.info${i}`).style.display = "none";
        }
      }

      this.group.add(this.cylinderZ);
      this.group.add(this.axisZr);
      this.group.add(this.axisZ);

      this.group.add(this.textMeshZ);
      this.scene.rotation.x = 0;
      this.group.rotation.x = 0;
      this.textMeshY.rotation.x = 0;
      this.textMesh.rotation.x = 0;
    },
    step2() {
      const geometry = new Three.TorusKnotGeometry(10, 3, 100, 16);
      const material = new Three.MeshNormalMaterial();
      this.torusKnot = new Three.Mesh(geometry, material);
      this.torusKnot.scale.set(0.2, 0.2, 0.2);
      this.torusKnot.rotation.z = 1;
      this.torusKnot.rotation.x = 1;
      this.group.add(this.torusKnot);
      this.info1 = true;
      this.group.add(this.textMeshZ);

      this.group.rotation.z = 0;

      this.textMeshY.rotation.x = -Math.PI / 2;
      this.textMesh.rotation.x = -Math.PI / 2;

      for (let i = 1; i <= 9; i++) {
        if (i <= 2) {
          document.querySelector(`.info${i}`).style.display = "block";
        } else {
          document.querySelector(`.info${i}`).style.display = "none";
        }
      }

      new TWEEN.Tween(this.scene.rotation)
        .to(
          {
            x: 0.2,
          },
          2500
        )
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {})
        .start();
      new TWEEN.Tween(this.scene.position)
        .to(
          {
            y: -1,
          },
          2500
        )
        .easing(TWEEN.Easing.Cubic.InOut)
        .start();
      new TWEEN.Tween(this.group.rotation)
        .to(
          {
            x: Math.PI / 2,
          },
          2500
        )
        .easing(TWEEN.Easing.Cubic.InOut)
        .start();
    },
    step3() {
      this.group.rotation.z = 0;
      document.querySelector(`.info3`).style.display = "block";
      new TWEEN.Tween(this.group.rotation)
        .to(
          {
            z: Math.PI / 3,
          },
          3500
        )
        .easing(TWEEN.Easing.Cubic.InOut)
        .start();
    },
    step4() {
      for (let i = 1; i <= 9; i++) {
        if (i <= 3) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else if (i >= 6) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else {
          document.querySelector(`.info${i}`).style.display = "block";
        }
      }

      this.group.rotation.z = Math.PI / 3;
      this.scene.position.y = -1;

      this.group.rotation.x = Math.PI / 2;

      this.group.add(this.gridHelper);
      this.group.add(this.gridHelperZX);
      this.group.add(this.gridHelperYZ);

      new TWEEN.Tween(this.group.rotation)
        .to(
          {
            z: -Math.PI / 3,
          },
          3500
        )
        .easing(TWEEN.Easing.Cubic.InOut)
        .onComplete(() => {})
        .start();
    },
    step5() {
      this.group.add(this.sphere);
      for (let i = 1; i <= 9; i++) {
        if (i <= 3) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else if (i >= 7) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else {
          document.querySelector(`.info${i}`).style.display = "block";
        }
      }
    },
    step6() {
      for (let i = 1; i <= 9; i++) {
        if (i <= 6) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else if (i >= 8) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else {
          document.querySelector(`.info${i}`).style.display = "block";
        }
      }
      this.group.add(this.gridHelper);
      this.group.add(this.gridHelperZX);
      this.group.add(this.gridHelperYZ);
      this.group.add(this.sphere);
      this.group.rotation.z = -Math.PI / 3;

      for (let i = 4; i <= 6; i++) {
        if (i <= 6) {
          document
            .querySelector(`.info${i}`)
            .classList.remove("animate__fadeInRight");
          document.querySelector(`.info${i}`).classList.add("animate__fadeOut");
        }
      }
      // setTimeout(() => {
      //   for (let i = 1; i <= 9; i++) {
      //     if (i <= 6) {
      //       document.querySelector(`.info${i}`).style.display = "none";
      //     } else if (i >= 8) {
      //       document.querySelector(`.info${i}`).style.display = "none";
      //     } else {
      //       // console.log(`.info${i}`);
      //       document.querySelector(`.info${i}`).style.display = "block";
      //     }
      //   }
      // }, 1000);
    },
    step7() {
      for (let i = 1; i <= 9; i++) {
        if (i <= 6) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else if (i >= 9) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else {
          document.querySelector(`.info${i}`).style.display = "block";
        }
      }
      document.querySelector(`.final`).style.display = "none";
      document.querySelector(`.info8`).style.display = "block";
    },
    step8() {
      for (let i = 1; i <= 9; i++) {
        if (i <= 3) {
          document.querySelector(`.info${i}`).style.display = "none";
        } else if (i >= 7) {
          document.querySelector(`.info${i}`).style.display = "block";
        } else {
          document.querySelector(`.info${i}`).style.display = "none";
        }
      }

      document.querySelector(`.final`).style.display = "block";

      if (this.logros.indexOf("TeoriaCuaterniones") != -1) {
        console.log("ya tiene este logro");
      } else {
        this.puntaje += 10;
        this.logros.push("TeoriaCuaterniones");
        fetch(`https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: `{"logros":${JSON.stringify(this.logros)},"puntaje":${
            this.puntaje
          }}`,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((err) => {
            console.error(err);
          });
      }
      // console.log(`{"logros":[${JSON.stringify(this.logros)}]}`);
    },
    step9() {
      this.felicidades = true;
    },
    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          console.log(response.data);
          this.imageUser = response.data.img;
          this.logros = response.data.logros;
          this.puntaje = response.data.puntaje;
          // console.log(this.puntaje);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    this.profile();
    this.init();
    this.animate();
    setTimeout(() => {
      this.siguiente = true;
    }, 1000);
  },
  watch: {
    // comenzar(nuevoValor, valorAnterior) {
    //   console.log(
    //     "El comenzar pasó de ser '%s' a '%s'",
    //     valorAnterior,
    //     nuevoValor
    //   );
    //   this.comenzarJuego();
    // },
  },
};
</script>
<style scoped>
.menu {
  position: absolute;
}
.arrow {
  position: absolute;

  width: 3vmin;
  height: 3vmin;
  background: transparent;
  border-top: 1vmin solid white;
  border-right: 1vmin solid white;
  box-shadow: 0 0 0 lightgray;
  transition: all 200ms ease;
  margin: 0 4rem;
}
.left {
  left: 0;
  transform: translate3d(0, -50%, 0) rotate(-135deg);
}

.right {
  right: 0;
  transform: translate3d(0, -50%, 0) rotate(45deg);
}
.flechas {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  bottom: 0;
  margin-bottom: 5rem;
  width: 15rem;
}
.arrow:hover {
  border-color: orange;
  box-shadow: 0.5vmin -0.5vmin 0 white;
}

.arrow:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-40%, -60%) rotate(45deg);
  width: 200%;
  height: 200%;
}
:root {
  --espacio: fit-content;
}
.felicidades a {
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem;
}
#container {
  height: 100vh;
  width: 100vw;
}
.info1,
.info2,
.info3,
.info4,
.info5,
.info6,
.info7,
.info8,
.info9 {
  display: none;
  position: absolute;
  background: #fff;
  width: 40%;
  right: 0;
  top: 5rem;
  padding: 1rem;
  border-end-start-radius: 5px;
  border-start-start-radius: 5px;
}

.info1 {
  display: block;
}
.info2,
.info5 {
  top: 12rem;
}
.info5,
.info8 {
  top: 15rem;
}
.final {
  display: none;
}
.info3,
.info6,
.info9,
.final {
  /* right: none;
  left: 0; */
  top: 22rem;
}
.info {
  position: absolute;
  width: fit-content;
  height: fit-content;
  right: 0;
  left: 0;
  bottom: -5rem;
  top: 0;
  margin: auto;
}
.info_texto span {
  font-size: 3rem;
  font-weight: bold;
}

h3 span {
  font-weight: bold;
}
.info_texto span:nth-child(1),
h3 span:nth-child(1) {
  color: red;
}
.info_texto span:nth-child(2),
h3 span:nth-child(2) {
  color: #00ff00;
}
.info_texto span:nth-child(3),
h3 span:nth-child(3) {
  color: #0000ff;
}
h2 {
  position: absolute;
  margin-top: 1rem;
  margin: auto;
  right: 0;
  left: 0;
  width: fit-content;
  font-size: 1.5rem;
  color: white;
  font-weight: bold;
  font-family: "Exo 2", sans-serif;
}
p {
  position: relative;
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  width: 65%;

  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: fit-content;
  font-family: "Roboto Mono", monospace !important;
  color: rgb(0, 255, 0);
}
.loader {
  position: relative;
  width: fit-content;
  margin: auto;
  right: 0;
  left: 0;
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 25%;
  max-width: 25%;
  height: 200px;
  align-items: center;
  justify-content: center;
}
.pacman {
  position: relative;
}
.pacman > div:nth-child(2) {
  -webkit-animation: pacman-balls 1s 1.99s infinite linear;
  animation: pacman-balls 1s 1.99s infinite linear;
}
.pacman > div:nth-child(3) {
  -webkit-animation: pacman-balls 1s 1.66s infinite linear;
  animation: pacman-balls 1s 1.66s infinite linear;
}
.pacman > div:nth-child(4) {
  -webkit-animation: pacman-balls 1s 1.33s infinite linear;
  animation: pacman-balls 1s 1.33s infinite linear;
}
.pacman > div:nth-child(5) {
  -webkit-animation: pacman-balls 1s 1s infinite linear;
  animation: pacman-balls 1s 1s infinite linear;
}
.pacman > div:first-of-type {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid yellow;
  border-left: 25px solid yellow;
  border-bottom: 25px solid yellow;
  border-radius: 25px;
  -webkit-animation: rotate_pacman_half_up 0.5s 1s infinite;
  animation: rotate_pacman_half_up 0.5s 1s infinite;
  position: relative;
  left: -30px;
  z-index: 100;
}
.pacman > div:nth-child(2) {
  width: 0px;
  height: 0px;
  border-right: 25px solid transparent;
  border-top: 25px solid yellow;
  border-left: 25px solid yellow;
  border-bottom: 25px solid yellow;
  border-radius: 25px;
  -webkit-animation: rotate_pacman_half_down 0.5s 1s infinite;
  animation: rotate_pacman_half_down 0.5s 1s infinite;
  margin-top: -50px;
  position: relative;
  left: -30px;
  z-index: 100;
}
.pacman > div:nth-child(3),
.pacman > div:nth-child(4),
.pacman > div:nth-child(5),
.pacman > div:nth-child(6) {
  background-color: red;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  margin: 2px;
  width: 10px;
  height: 10px;
  position: absolute;
  -webkit-transform: translate(0, -6.25px);
  transform: translate(0, -6.25px);
  top: 25px;
  left: 70px;
}
.next {
  font-size: 4rem;
  color: white;
  transition-duration: 0.3s;
  cursor: pointer;
}
.next:hover {
  color: #00ff00;
  transform: scale(1.2);
}
.felicidades {
  position: absolute;
  background: white;
  border-radius: 10px;
  width: 40%;
  height: fit-content;
  /* height: 50%; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  font-family: "Exo 2", sans-serif !important;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.felicidades h2 {
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-family: "Exo 2", sans-serif !important;
  color: black;
}
.felicidades p {
  color: black;
  /* font-weight: bold; */
  font-family: "Exo 2", sans-serif !important;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.felicidades img {
  margin: 1rem;
  width: 35%;
}
@-webkit-keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  50% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
}

@keyframes rotate_pacman_half_up {
  0% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
  50% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
  100% {
    -webkit-transform: rotate(270deg);
    transform: rotate(270deg);
  }
}

@-webkit-keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@keyframes rotate_pacman_half_down {
  0% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
  50% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@-webkit-keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}

@keyframes pacman-balls {
  75% {
    opacity: 0.7;
  }
  100% {
    -webkit-transform: translate(-100px, -6.25px);
    transform: translate(-100px, -6.25px);
  }
}
.profundizacion {
  position: absolute;
  left: 0;
  /* top: -5rem; */
  bottom: 5rem;
  height: fit-content;
  margin: auto;
}
.profundizacion h3 {
  font-weight: bold;
  color: white;
  font-size: 1.2rem;
}
iframe {
  width: 460px;
  height: 300px;
}
</style>
